const getOr = require('lodash/fp/getOr');

const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');
const parsePosition = require('../resources/assets-common/parse-position');
const parseTransaction = require('../resources/assets-common/parse-transaction');
const merge = require('lodash/fp/merge');

function parseLoansPosition(position) {
  const p = path => getOr(null, path, position);

  return merge(
    parsePosition(position),
    {
      amount: p('psLoanAmt'),
      accruedInterest: p('psAccIntRefCcy'),
      maturityDate: p('psMtrDte'),
      maturityInterest: p('psTotIntRefCcy'),
      maturityInterestPosCcy: p('psTotIntPosCcy'),
      maturityInterestPandI: p('psPiRefccy'),
      maturityInterestPandIPosCcy: p('psPiPosccy'),
    }
  );
}

function parseLoansTransaction(transaction) {
  const t = path => getOr(null, path, transaction);

  return merge(parseTransaction(transaction),
    {
      reference: t('tradeNo'),
      type: t('tranTypeDesc'),
      amount: parseFloat(t('netAmtTradeCcy')),
      currency: t('ccyTrade'),
    }
  );
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/loan/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '4',
    positionsUrl: 'loan-positions',
    transactionsUrl: 'loan-transactions',
    valueMovementUrl: 'loan-value-movement',
  });

  const service = serviceFactory({
    api,
    parsePosition: parseLoansPosition,
    parseTransaction: parseLoansTransaction,
  });

  return routeAdderFactory({ assetType: 'loans', service });
}

module.exports = addRoutes;
